import { useQuery } from "@apollo/client/react";
import { EscoAvailabilityDocument } from "@/graphql/generated/operations";

/** Deployment-owned capability; loading/errors fail closed without calling ESCO. */
export function useEscoEnabled() {
  const { data, loading, error } = useQuery(EscoAvailabilityDocument);
  return !loading && !error && data?.escoEnabled === true;
}
